export default __webpack_public_path__ + "static/media/CulturalPortal.ac380b82.gif";